module.exports = __webpack_public_path__ + "a1997d133965430f06e7b1a0f581dd60.ttf";